import apiClient from '../clienteFebosAPI';

const RESOURCE = '/actividades';

const activityFromApi = (activity) => ({
  ...(activity.actividadId && { id: activity.actividadId }),
  ...(activity.elementoTipo && { referenceType: activity.elementoTipo }),
  ...(activity.elementoId && { referenceId: activity.elementoId }),
  ...(activity.usuarioAsignadoId && { targetUserId: activity.usuarioAsignadoId }),
  ...(activity.usuarioAsignadoNombre && { targetUserName: activity.usuarioAsignadoNombre }),
  ...(activity.nombre && { name: activity.nombre }),
  ...(activity.descripcion && { description: activity.descripcion }),
  ...(activity.estadoSistema && { statusValue: activity.estadoSistema }),
  ...(activity.estadoSistemaDescripcion && { statusName: activity.estadoSistemaDescripcion }),
  ...(activity.empresaId && { companyId: activity.empresaId }),
  ...(activity.estadoEmpresa && { companyStatusValue: activity.estadoEmpresa }),
  ...(activity.estadoEmpresaDescripcion
    && { companyStatusName: activity.estadoEmpresaDescripcion }
  ),
  ...(activity.categoria && { categoryValue: activity.categoria }),
  ...(activity.categoriaDescripcion && { categoryName: activity.categoriaDescripcion }),
  ...(activity.columna && { column: activity.columna }),
  ...(activity.urgencia && { priority: activity.urgencia }),
  ...(activity.fechaActualizacion && { updatedAt: activity.fechaActualizacion }),
  ...(activity.fechaCreacion && { createdAt: activity.fechaCreacion }),
  ...(activity.fechaVencimiento && { expiredAt: activity.fechaVencimiento }),
  ...(activity.referenciaElementoTipo && { referenceElementType: activity.referenciaElementoTipo }),
  ...(activity.referenciaElementoNumero
    && { referenceElementNumber: activity.referenciaElementoNumero }
  )
});

const activityToApi = (activity) => ({
  ...(activity.referenceElementType && { referenciaElementoTipo: activity.referenceElementType }),
  ...(activity.referenceElementNumber
    && { referenciaElementoNumero: activity.referenceElementNumber }),
  ...(activity.referenceType && { elementoTipo: activity.referenceType }),
  ...(activity.referenceId && { elementoId: activity.referenceId }),
  ...(activity.targetUserId && { usuarioAsignadoId: activity.targetUserId }),
  ...(activity.name && { nombre: activity.name }),
  ...(activity.description && { descripcion: activity.description }),
  ...(activity.statusValue && { estadoSistema: activity.statusValue }),
  ...(activity.statusName && { estadoSistemaDescripcion: activity.statusName }),
  ...(activity.companyStatusValue && { estadoEmpresa: activity.companyStatusValue }),
  ...(activity.companyStatusName && { estadoEmpresaDescripcion: activity.companyStatusName }),
  ...(activity.categoryValue && { categoria: activity.categoryValue }),
  ...(activity.categoryName && { categoriaDescripcion: activity.categoryName }),
  ...(activity.statusValue && { columna: activity.statusValue }),
  ...(activity.priority && { urgencia: activity.priority }),
  ...(activity.expiredAt && { fechaVencimiento: activity.expiredAt })
});

const attachmentToApi = (attachment) => ({
  ...(attachment.url && { adjuntoUrl: attachment.url }),
  ...(attachment.name && { adjuntoNombre: attachment.name }),
});

const attachmentFromApi = (attachment) => ({
  ...(attachment.adjuntoId && { id: attachment.adjuntoId }),
  ...(attachment.adjuntoUrl && { url: attachment.adjuntoUrl }),
  ...(attachment.adjuntoNombre && { name: attachment.adjuntoNombre }),
});

const commentFromApi = (comment) => ({
  ...(comment.comentarioId && { id: comment.comentarioId }),
  ...(comment.comentario && { text: comment.comentario }),
  ...(comment.elementoId && { referenceId: comment.elementoId }),
  ...(comment.usuarioId && { userId: comment.usuarioId }),
  ...(comment.usuarioNombre && { username: comment.usuarioNombre }),
  ...(comment.usuarioAvatar && { userAvatar: comment.usuarioAvatar }),
  ...(comment.fecha && { createdAt: comment.fecha }),
  ...(comment.estado && { status: comment.estado }),
  ...({
    attachments: comment.adjuntos
      ? comment.adjuntos.map(((attachments) => attachmentFromApi(attachments)))
      : []
  })
});

const commentToApi = (comment) => ({
  ...(comment.text && { comentario: comment.text }),
  ...(comment.attachments
    && { adjuntos: comment.attachments.map((attachment) => attachmentToApi(attachment)) })
});

export const clActivityCreate = async (activityRequest) => {
  const body = activityToApi(activityRequest);
  const { data: { actividad: activity } } = await apiClient.post(
    `${RESOURCE}/`,
    body,
    { operacionId: 'cl.actividad.crear' }
  );
  return activityFromApi(activity);
};

export const clActivityUpdate = async (activityId, activityRequest) => {
  const body = activityToApi(activityRequest);
  const { data: { actividad: activity } } = await apiClient.put(
    `${RESOURCE}/${activityId}`,
    body,
    { operacionId: 'cl.actividad.actualizar' }
  );
  return activityFromApi(activity);
};

export const clActivityList = async (
  referenceId,
  filters = '',
  order = '-fechaActualizacion',
  page = 1,
  perPage = 1000
) => {
  const filtersToApply = [
    referenceId && `elementoId:${referenceId}`,
    filters
  ]
    .filter((filter) => !!filter)
    .join('|');
  const params = apiClient.queryParams({
    orden: order,
    paginaActual: page,
    elementosPorPagina: perPage,
    filtros: filtersToApply
  });
  const { data: { actividades: activities } } = await apiClient.get(
    `${RESOURCE}/?${params}`,
    { operacionId: 'cl.actividad.listar' }
  );
  return activities.map((activity) => activityFromApi(activity));
};

export const clActivityDetail = async (activityId) => {
  const { data: { actividad: activity } } = await apiClient.get(
    `${RESOURCE}/${activityId}`,
    { operacionId: 'cl.actividad.detalle' }
  );
  return activityFromApi(activity);
};

export const clActivityCommentCreate = async (activityId, commentRequest) => {
  const body = commentToApi(commentRequest);
  const { data: { comentario: comment } } = await apiClient.post(
    `${RESOURCE}/${activityId}/comentarios`,
    body,
    { operacionId: 'cl.actividad.comentario.crear' }
  );
  return commentFromApi(comment);
};

export const clActivityCommentList = async (
  activityId,
  page = 1,
  perPage = 10,
  order = '-fecha'
) => {
  const params = apiClient.queryParams({
    orden: order,
    paginaActual: page,
    elementosPorPagina: perPage
  });
  const {
    data: {
      comentarios: comments,
      totalPaginas: totalPages,
      paginaActual: currentPage
    }
  } = await apiClient.get(
    `${RESOURCE}/${activityId}/comentarios/?${params}`,
    { operacionId: 'cl.actividad.comentario.listar' }
  );
  return {
    comments: comments.map((comment) => commentFromApi(comment)),
    totalPages,
    currentPage
  };
};
